import "@finn-no/favorite-heart-component/dist/style.css";
import ReactDOM from "react-dom/client";
import type { AppProps } from "types/app.ts";
import "virtual:uno.css";
import App from "./App.tsx";
import { dynamicActivate } from "./i18n.ts";

const root = document.querySelector("#mobility-dealer-branding-layout-root");

async function hydrate() {
  const encodedProps = root?.getAttribute("data-props");
  const props: AppProps | undefined = encodedProps ? JSON.parse(decodeURIComponent(atob(encodedProps))) : undefined;

  if (encodedProps && root) {
    root.removeAttribute("data-props");
  }

  if (!root || !props || Object.keys(props).length === 0) {
    return;
  }

  await dynamicActivate(props.appConfig.locale);

  ReactDOM.hydrateRoot(root, <App {...props} />);
}

hydrate();
